// NextScene — minimal Contact Us page.
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import Footer from "@/components/Footer";
import { ArrowLeft, Mail } from "lucide-react";

export default function Contact() {
  return (
    <div style={{ backgroundColor: "#070709", minHeight: "100vh", color: "#F5F3EE", display: "flex", flexDirection: "column" }}>
      <div className="max-w-5xl mx-auto w-full px-5 md:px-8 pt-8 pb-6 flex items-center justify-between">
        <Link to="/" className="inline-flex items-center gap-2 text-[rgba(255,255,255,0.72)] hover:text-white"><ArrowLeft size={16}/> Back</Link>
        <Logo size="sm"/>
      </div>
      <div className="flex-1 flex items-center justify-center px-5 md:px-8" style={{ paddingTop: "80px", paddingBottom: "120px" }}>
        <div className="text-center" style={{ maxWidth: "620px" }}>
          <h1 style={{ fontFamily: "'Ogg', 'Ogg Regular', 'Didot', 'Bodoni Moda', 'Playfair Display', Georgia, serif", fontWeight: 400, fontSize: "clamp(44px, 5.5vw, 82px)", lineHeight: 1, letterSpacing: "-1.5px", margin: 0 }}>
            Contact <span style={{ fontStyle: "italic", color: "#C79A2B" }}>Us</span>
          </h1>
          <p style={{ marginTop: "22px", fontFamily: "'Inter', system-ui, sans-serif", fontSize: "18px", color: "rgba(255,255,255,0.72)", lineHeight: 1.6 }}>
            For general inquiries, partnerships, or support.
          </p>
          <a
            href="mailto:support@nextscene.in"
            data-testid="contact-email"
            style={{
              marginTop: "48px",
              display: "inline-flex",
              alignItems: "center",
              gap: "14px",
              padding: "20px 32px",
              borderRadius: "999px",
              border: "1px solid rgba(199,154,43,0.55)",
              background: "rgba(199,154,43,0.06)",
              color: "#F5F3EE",
              fontFamily: "'Inter', system-ui, sans-serif",
              fontSize: "22px",
              fontWeight: 500,
              letterSpacing: "0.2px",
              textDecoration: "none",
              boxShadow: "0 0 24px rgba(199,154,43,0.14)",
              transition: "background 220ms ease, box-shadow 220ms ease",
            }}
          >
            <Mail size={20} color="#C79A2B" />
            support@nextscene.in
          </a>
        </div>
      </div>
      <Footer/>
    </div>
  );
}
